document.addEventListener("DOMContentLoaded", () => {
    const html = document.documentElement;
  
    /* ----------------------------
       MOBILE MENU
    ----------------------------- */
    const headerSection =
      document.querySelector("#shopify-section-header") ||
      document.querySelector(".header-shopify-section");
    const mainMobileMenu = headerSection?.querySelector("#mobile_nav") ?? document.querySelector("#mobile_nav");
    const mobileMenu =
      mainMobileMenu?.querySelector(".mobile-menu-container") ??
      document.querySelector(".mobile-menu-container");
    const mobileToggle =
      mainMobileMenu?.querySelector(".mobile_left") ?? document.querySelector(".mobile_left");
    const mobileOpen =
      mainMobileMenu?.querySelector(".mobile-open") ?? document.querySelector(".mobile-open");
    const mobileClosed =
      mainMobileMenu?.querySelector(".mobile-closed") ?? document.querySelector(".mobile-closed");
    const topBar = document.querySelector(".tw-bg-primary");
    const mobileTopBar =
      mainMobileMenu?.querySelector(".mobile_wrapper") ?? document.querySelector(".mobile_wrapper");
    const backdrop = document.querySelector("#nav-backdrop");

    // Move backdrop to <body> so position:fixed is never trapped inside a
    // sticky/transformed ancestor (which would make it scroll with the page).
    if (backdrop) document.body.appendChild(backdrop);

    const syncMobileBackdropTop = () => {
      if (!backdrop || !mobileTopBar) return;
      const headerEl =
        document.querySelector(".header-shopify-section") ||
        document.querySelector("#shopify-section-header");
      const announcementEl = document.querySelector(".announcement-bar");
      if (!headerEl || !announcementEl) return;
      backdrop.style.top = headerEl.offsetHeight + announcementEl.offsetHeight + "px";
    };
  
    const toggleMobileMenu = () => {
      if (!mobileMenu) return;
      const isOpen = mobileMenu.classList.toggle("is-open");

      // Apply scroll lock immediately — must not run after code that can throw
      // (e.g. missing #mobile_nav previously prevented this line from running).
      html.classList.toggle("body-no-scroll", isOpen);

      if (mobileOpen) mobileOpen.hidden = isOpen;
      if (mobileClosed) {
        mobileClosed.hidden = !isOpen;
        if (isOpen) {
          mobileClosed.classList.add("opened");
          mobileClosed.removeAttribute("hidden");
        } else {
          mobileClosed.classList.remove("opened");
        }
      }

      mainMobileMenu?.classList.toggle("mobile-height", isOpen);
      if (topBar) topBar.style.opacity = isOpen ? 0 : 1;
      if(topBar) topBar.style.display = isOpen ? "none" : "block";
      if(mainMobileMenu) mainMobileMenu.style.marginTop = isOpen ? "0px" : "0";

      if (backdrop) {
        if (isOpen) {
          requestAnimationFrame(() => {
            syncMobileBackdropTop();
            backdrop.classList.add("is-active");
          });
          window.addEventListener("scroll", syncMobileBackdropTop, { passive: true });
        } else {
          backdrop.classList.remove("is-active");
          backdrop.style.top = "";
          window.removeEventListener("scroll", syncMobileBackdropTop);
        }
      }
    };
  
    if (mobileToggle && mobileMenu) {
      mobileToggle.addEventListener("click", toggleMobileMenu);
    }

    /* Close menu on Escape */
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && mobileMenu?.classList?.contains("is-open")) {
        toggleMobileMenu();
      }
    });

    /* Close menu when clicking on menu links */
    const closeMenuOnLinkClick = (e) => {
      // Don't close if clicking on a submenu toggle or non-navigation link
      const target = e.target.closest("a");
      if (!target || target.hasAttribute("data-toggle") || target.classList.contains("mobile-nav__return-btn")) {
        return;
      }
      
      if (mobileMenu?.classList?.contains("is-open")) {
        toggleMobileMenu();
      }
    };

    // Add click listeners to all links in the mobile menu
    if (mainMobileMenu) {
      const menuLinks = mainMobileMenu.querySelectorAll("a");
      menuLinks.forEach(link => {
        link.addEventListener("click", closeMenuOnLinkClick);
      });
    }

    // Also handle clicks on mobile menu container links (like the cards at the top)
    if (mobileMenu) {
      const allMenuLinks = mobileMenu.querySelectorAll("a");
      allMenuLinks.forEach(link => {
        link.addEventListener("click", closeMenuOnLinkClick);
      });
    }

    // Ensure body-no-scroll is removed on page navigation (especially for collections pages)
    // This handles cases where AJAX navigation might not properly clean up
    const isMegaMenuOpen = () =>
      document.querySelector(".header-block-mega")?.classList?.contains("is-open") ?? false;

    const isMobileNavMenuOpen = () =>
      Boolean(document.querySelector("#mobile_nav .mobile-menu-container.is-open"));

    const removeBodyNoScrollOnNavigation = () => {
      // Small delay to ensure it runs after any AJAX updates
      setTimeout(() => {
        if (document.documentElement.classList.contains("body-no-scroll")) {
          // Only remove if menu is actually closed and drawer is not open
          const isMenuOpen = isMobileNavMenuOpen();
          const isDrawerOpen = document.querySelector("collection-drawer[data-visible='true']");

          if (!isMenuOpen && !isDrawerOpen && !isMegaMenuOpen()) {
            document.documentElement.classList.remove("body-no-scroll");
          }
        }
      }, 100);
    };

    // Check on initial page load - remove body-no-scroll if menu is not open
    const checkInitialState = () => {
      if (document.documentElement.classList.contains("body-no-scroll")) {
        const isMenuOpen = isMobileNavMenuOpen();
        const isDrawerOpen = document.querySelector("collection-drawer[data-visible='true']");

        if (!isMenuOpen && !isDrawerOpen && !isMegaMenuOpen()) {
          document.documentElement.classList.remove("body-no-scroll");
        }
      }
    };
    
    // Check immediately and after a short delay (in case of delayed initialization)
    checkInitialState();
    setTimeout(checkInitialState, 500);

    // Listen for navigation events
    window.addEventListener("popstate", removeBodyNoScrollOnNavigation);
    
    // Also check after AJAX updates (for collections pages with filters)
    // Use a debounced approach to avoid excessive checks
    let checkTimeout;
    const debouncedCheck = () => {
      clearTimeout(checkTimeout);
      checkTimeout = setTimeout(removeBodyNoScrollOnNavigation, 200);
    };
    
    const observer = new MutationObserver((mutations) => {
      // Only check if we're on a collections page or if there are significant DOM changes
      const isCollectionsPage = window.location.pathname.includes('/collections/');
      if (isCollectionsPage) {
        debouncedCheck();
      }
    });

    // Observe the body for changes (which might indicate page updates)
    observer.observe(document.body, {
      childList: true,
      subtree: false, // Only watch direct children to reduce overhead
      attributes: false
    });
  
    /* ----------------------------
       DESKTOP DROPDOWN (SHOP)
    ----------------------------- */
    const shopButton = document.querySelector(".shop-button");
    const shopArrow = document.querySelector(".shop-arrow");
    const megaMenu = document.querySelector(".header-block-mega");
  
    if (shopButton && megaMenu) {
      const syncBackdropTop = () => {
        if (!backdrop) return;
        const headerEl =
          document.querySelector(".header-shopify-section") ||
          document.querySelector("#shopify-section-header");
        const announcementEl = document.querySelector(".announcement-bar");
        if (!headerEl || !announcementEl) return;
        backdrop.style.top = headerEl.offsetHeight + announcementEl.offsetHeight + "px";
      };

      const openMenu = () => {
        megaMenu.classList.add("is-open");
        html.classList.add("body-no-scroll");
        shopButton.setAttribute("aria-expanded", "true");
        if (shopArrow) shopArrow.style.transform = "rotate(180deg)";
        if (backdrop) {
          requestAnimationFrame(() => {
            syncBackdropTop();
            backdrop.classList.add("is-active");
          });
          window.addEventListener("scroll", syncBackdropTop, { passive: true });
        }
      };
  
      const closeMenu = () => {
        // Guard: document-level listeners call this on many clicks/key events.
        // If mega is already closed, do nothing — otherwise we strip html.body-no-scroll
        // while the mobile drawer menu is open (mobile toggle clicks bubble to document).
        if (!megaMenu.classList.contains("is-open")) return;
        megaMenu.classList.remove("is-open");
        html.classList.remove("body-no-scroll");
        shopButton.setAttribute("aria-expanded", "false");
        if (shopArrow) shopArrow.style.transform = "rotate(0deg)";
        if (backdrop) {
          backdrop.classList.remove("is-active");
          backdrop.style.top = "";
          window.removeEventListener("scroll", syncBackdropTop);
        }
      };
  
      const toggleMenu = (e) => {
        e.stopPropagation();
        megaMenu.classList.contains("is-open") ? closeMenu() : openMenu();
      };
  
      shopButton.addEventListener("click", toggleMenu);
  
      /* Close dropdown when clicking outside */
      document.addEventListener("click", (e) => {
        if (!megaMenu.classList.contains("is-open")) return;
        if (!megaMenu.contains(e.target) && !shopButton.contains(e.target)) {
          closeMenu();
        }
      });
  
      /* Close dropdown on Escape */
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && megaMenu.classList.contains("is-open")) closeMenu();
      });
    }

    if (typeof window.upcartSubscribeCartLoaded === "function") {
      window.upcartSubscribeCartLoaded(({ cart }) => {
        const totalQuantity = cart?.items || [];
        const totalItems = totalQuantity.reduce((sum, item) => sum + item.quantity, 0);
        const cartCountElements = document.querySelectorAll('.header__bag__count p[data-count]');
        if (cartCountElements.length) {
          cartCountElements.forEach(el => {
            el.textContent = totalItems;
            el.setAttribute('data-count', totalItems);
          });
        }
      });
    }
  });
  